export class SetPlacementUserViewStatus {
    public static readonly type = '[JobsPlacements] Set placement user view status';

    constructor(public placementId: number) {}
}
